import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const CancelAppointmentSubHeader = styled(Typography, {
  name: 'CancelAppointmentSubHeader',
  slot: 'Root',
  skipSx: true,
})`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  /* identical to box height, or 24px */

  letter-spacing: 0.15px;

  /* Text/Primary */

  color: theme.palette.text.primary;
`
